import * as React from 'react';

import { sampleOne } from '@/utils';
import useSound from '@/hooks/use-sound';

const SPRITES: Record<string, [number, number]> = {
  a: [89, 20],
  b: [141, 20],
  c: [183, 20],
  d: [225, 20],
  e: [295, 20],
  f: [353, 20],
};

export default function useTickSfx() {
  const [lowLevelPlayFn] = useSound('/sounds/tick-sprite.mp3', {
    sprite: SPRITES,
    volume: 0.15,
  });

  const playTick = React.useCallback(() => {
    lowLevelPlayFn({ id: sampleOne(Object.keys(SPRITES)) });
  }, [lowLevelPlayFn]);

  return playTick;
}
